import React, {useEffect} from "react";
import Navbar from "../../utils/components/navbar/Navbar";
import './OnePage.css';
import Logo from '../../img/logo.png'
import pinPointIcon from '../../img/pin_point.svg'
import whatsappWhiteIcon from '../../img/whatsapp-icon-white.png'
import Footer from "../../utils/components/footer/Footer";
import alineImage from "../../img/aline_image.jpg";
import gabrielaImage from "../../img/gabriela_image.jpg";

const OnePage = () => {

    return (
        <>
            <header>
                <div className="header_logo">
                    <img src={Logo}/>
                    <div className="text-logo">
                        <h1>Rodrigues & Mafra</h1>
                        <span>Sociedade de Advogados</span>
                    </div>
                </div>
                <div className="header_menu">
                    <div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                            <mask id="mask0_3_17" style={{maskType: "alpha"}} maskUnits="userSpaceOnUse" x="0" y="0"
                                  width="48"
                                  height="48">
                                <rect width="48" height="48" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_3_17)">
                                <path
                                    d="M7.5 36C7.075 36 6.71875 35.8554 6.43125 35.5663C6.14375 35.2771 6 34.9187 6 34.4913C6 34.0638 6.14375 33.7083 6.43125 33.425C6.71875 33.1417 7.075 33 7.5 33H40.5C40.925 33 41.2813 33.1446 41.5688 33.4338C41.8563 33.7229 42 34.0813 42 34.5087C42 34.9362 41.8563 35.2917 41.5688 35.575C41.2813 35.8583 40.925 36 40.5 36H7.5ZM7.5 25.5C7.075 25.5 6.71875 25.3554 6.43125 25.0663C6.14375 24.7771 6 24.4187 6 23.9913C6 23.5638 6.14375 23.2083 6.43125 22.925C6.71875 22.6417 7.075 22.5 7.5 22.5H40.5C40.925 22.5 41.2813 22.6446 41.5688 22.9337C41.8563 23.2229 42 23.5813 42 24.0087C42 24.4362 41.8563 24.7917 41.5688 25.075C41.2813 25.3583 40.925 25.5 40.5 25.5H7.5ZM7.5 15C7.075 15 6.71875 14.8554 6.43125 14.5663C6.14375 14.2771 6 13.9187 6 13.4913C6 13.0638 6.14375 12.7083 6.43125 12.425C6.71875 12.1417 7.075 12 7.5 12H40.5C40.925 12 41.2813 12.1446 41.5688 12.4337C41.8563 12.7229 42 13.0813 42 13.5087C42 13.9362 41.8563 14.2917 41.5688 14.575C41.2813 14.8583 40.925 15 40.5 15H7.5Z"
                                    fill="white"/>
                            </g>
                        </svg>
                    </div>
                    <div>
                        <ul>
                            <a href="#">
                                <li className="active">Home</li>
                            </a>
                            <a href="#sobre">
                                <li>Sobre</li>
                            </a>
                            <a href="#atuacao">
                                <li>Atuação</li>
                            </a>
                            <a href="#advogados">
                                <li>Advogados</li>
                            </a>
                            <a href="#contatos">
                                <li>Contatos</li>
                            </a>
                            <a href="/artigos">
                                <li>Artigos</li>
                            </a>
                        </ul>
                    </div>
                </div>
            </header>

            <Navbar/>

            <main>
                <section id="sobre">
                    <div className="container-fluid pl-5">
                        <h1 className="title-section">Sobre</h1>

                        <div className="row mt-5">
                            <div className="col-12">
                                <h1 className="sub-text f-50 px-5">“Um mundo <span>ético</span> não é uma dadiva da
                                    natureza,<br/>
                                    mas sim uma dura <span>conquista</span> da civilização.”<br/> – Lima Vaz, 1996.
                                </h1>
                            </div>
                        </div>

                        <div className="row mt-5 gy-5">
                            <div className="col-xl-6 col-lg-6 text-center d-flex flex-column align-items-center">
                                <h1 className="title-section">Missão</h1>

                                <h3 className="sub-text mt-3 w-75 font-weight-light text-center">
                                    Prestação de serviços jurídicos de excelência com soluções céleres e eficazes com
                                    ênfase em inventários extrajudiciais e judiciais, na área cível e outras.
                                </h3>
                            </div>

                            <div className="col-xl-6 col-lg-12 text-center d-flex flex-column align-items-center">
                                <h1 className="title-section">Valores</h1>

                                <h3 className="sub-text mt-3 w-75 font-weight-light text-center">
                                    Integridade ética,
                                    comprometimento,<br/>
                                    responsabilidade,
                                    organização<br/>
                                    e acima de tudo
                                    respeito, zelo<br/> e equidade nas causas de nossos clientes.
                                </h3>
                            </div>


                        </div>
                    </div>
                </section>

                <section className="container-fluid">

                    <div className="row">
                        <div className="col-lg-6">
                            <section id="atuacao" className="mt-0 p-0">
                                <div className="container-fluid">
                                    <h1 className="title-section">Atuação</h1>
                                </div>

                                <div className="pt-3 px-3 ps-lg-5 ">


                                    <div className="row gx-lg-2 gy-3">
                                        <div className="col-md-12 col-lg-12 d-flex">

                                            <div className="card text-center border-gold mt-3 shadow-card"
                                                 style={{width: "auto", height: "500px"}}>
                                <span className="material-symbols-rounded my-2">
                                    family_restroom
                                </span>
                                                <div className="card-body">
                                                    <h5 className="card-title">DIREITO DE FAMÍLIA/ SUCESSÕES</h5>
                                                    <h6>Escritório especializado em direitos da família e sucessões</h6>
                                                    <ul className="text-start">
                                                        <li>Divórcio</li>
                                                        <li>Pensão/Alimentos</li>
                                                        <li>Interdição/Tutela e Curatela</li>
                                                        <li>Guarda Judicial</li>
                                                        <li>Direitos de Visita</li>
                                                        <li>Inventários Judiciais e Extrajudiciais</li>
                                                        <li>Testamentos</li>
                                                        <li>Partilha de Bens</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </section>
                        </div>
                        <div className="col-lg-6">
                            <section className="mt-sm-5 mt-lg-0 p-0">
                                <div className="container-fluid ps-lg-0">
                                    <h1 className="title-section ms-lg-0">Outras áreas</h1>
                                </div>
                                <div className={"pe-md-5 pt-4"}>
                                    <div className="bg-blue px-3 rounded-3 pb-4 shadow-card">
                                        <div className="row gx-lg-2 gy-3 justify-content-md-center">
                                            <div className="col-md-6 col-lg-6 d-flex justify-content-center">
                                                <div className="card text-center"
                                                     style={{width: "auto", height: "500px"}}>
                                <span className="material-symbols-rounded my-2">
                                    corporate_fare
                                </span>
                                                    <div className="card-body">
                                                        <h5 className="card-title">EMPRESARIAL</h5>
                                                        <ul className="text-start">
                                                            <li>Recuperação de Créditos</li>
                                                            <li>Ações de Execução</li>
                                                            <li>Ações de Cobrança</li>
                                                            <li>Ações Monitórias</li>
                                                            <li>Ações de Busca e Apreensão</li>
                                                            <li>Requerimento de Falências</li>
                                                            <li>Habilitação de Créditos</li>
                                                            <li>Impugnação de Créditos Declarados</li>
                                                            <li>Assessoria para o Recebimento de Créditos ou
                                                                Pagamento de Débitos Através de Acordos Judiciais ou
                                                                Extrajudiciais
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6 col-lg-6 d-flex justify-content-center">
                                                <div className="card text-center"
                                                     style={{width: "auto", height: "500px"}}>
                                <span className="material-symbols-rounded my-2">
                                    person
                                </span>
                                                    <div className="card-body">
                                                        <h5 className="card-title">CÍVEL GERAL</h5>
                                                        <ul className="text-start">
                                                            <li>Responsabilidade Civil</li>
                                                            <li>Propositura de Medidas Judiciais e Extrajudiciais
                                                                Visando à Proteção de Direitos Civis
                                                            </li>
                                                            <li>Ajuizamento e Defesa em Ações de Indenização
                                                                por Danos Materiais e Morais.
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                    </div>

                </section>

                <section id="advogados">
                    <div className="container-fluid pl-5">
                        <h1 className="title-section">Advogados</h1>

                        <div className="row gy-5 justify-content-center mt-3">
                            <div className="col-12 col-sm-6 col-lg-3 d-flex justify-content-center">
                                <div
                                    className="card card-adv border-gold text-center d-flex flex-column align-items-center"
                                    style={{width: "18rem"}}>
                                    <img src={gabrielaImage}
                                         className="card-img-top mt-4" alt=""/>
                                    <div className="card-body">
                                        <h5 className="card-title">GABRIELA MAFRA DA FONSECA</h5>
                                        <p className="card-text"> Graduada pela PUC-Campinas em 2019 e especializada em
                                            Direito
                                            Civil e Processo Cível pela Universidade Mackenzie.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12 col-sm-6 col-lg-3 d-flex justify-content-center">
                                <div
                                    className="card card-adv border-gold text-center d-flex flex-column align-items-center"
                                    style={{width: "18rem"}}>
                                    <img src={alineImage}
                                    style={{objectPosition: "0px -10px"}}
                                         className="card-img-top mt-4" alt=""/>
                                    <div className="card-body">
                                        <h5 className="card-title">ALINE MENDONÇA RODRIGUES</h5>
                                        <p className="card-text">Pós Graduada em 2023 pela Universidade Damásio em Processo
                                            Civil.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <section id="contatos">
                    <div className="container-fluid pl-5">
                        <h1 className="title-section">Contatos</h1>
                    </div>

                    <div className="row flex-column-reverse flex-md-row g-0 bg-gradient-blue-white mt-5">
                        <div className="col-12 col-lg-6 py-lg-5">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.0909130481386!2d-46.66063881259844!3d-23.56517810704902!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce59c601921e43%3A0xbbcb2dc376c02a5d!2sAlameda%20Ja%C3%BA%2C%20684%20-%204%C2%B0%20andar%20-%20Jardim%20Paulista%2C%20S%C3%A3o%20Paulo%20-%20SP%2C%2001420-002!5e0!3m2!1spt-BR!2sbr!4v1703635656784!5m2!1spt-BR!2sb"
                                style={{border: 0}} height="600px" allowFullScreen="" loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade" className="w-100"></iframe>
                        </div>

                        <div className="col-12 col-lg-6 d-flex flex-column justify-content-center p-lg-5 p-3">
                            <div className="d-flex align-items-center gap-3">
                                <img src={pinPointIcon} width="50px" height="50px"/>
                                <a href="https://maps.app.goo.gl/GfLg6LBr5s9B4Jfx7" target="_blank"><span
                                    className="text-contato">Alameda Jaú, 684.
                                4° andar, Jd. Bela vista</span></a>
                            </div>

                            <div className="d-flex align-items-center mt-3 mb-3 gap-3">
                                <img src={whatsappWhiteIcon} width="50px" height="50px"/>
                                <a href="https://wa.me/5511994694069" target="_blank"><span className="text-contato">(11)
                                99469-4069</span></a>
                            </div>

                            <div className="d-flex align-items-center mt-3 mb-3 gap-3">
                                <img src={whatsappWhiteIcon} width="50px" height="50px"/>
                                <a href="https://wa.me/5511980961198" target="_blank"><span className="text-contato">(11)
                                98096-1198</span></a>
                            </div>

                        </div>
                    </div>
                </section>
            </main>

            <Footer/>
        </>
    )
}

export default OnePage;